// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let PageViews = require("../../../reason/PageViews.bs.js");
let QueryParams = require("../../../reason/QueryParams.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationsPageRelayCommon_conversationContext_graphql = require("../../../__generated__/ConversationsPageRelayCommon_conversationContext_graphql.bs.js");
let ConversationsPageRelayCommonGetClientNames_client_graphql = require("../../../__generated__/ConversationsPageRelayCommonGetClientNames_client_graphql.bs.js");

function toString(x) {
  switch (x) {
    case "BROADCAST_MESSAGE" :
      return "broadcast";
    case "BUYER_NEED" :
      return "buyer need";
    case "FOR_SALE_PROPERTY" :
      return "property";
    case "RENTAL_NEED" :
      return "rental need";
    case "RENTAL_PROPERTY" :
      return "rental property";
  }
}

let EntityType = {
  toString: toString
};

let Conversation = {};

function decodeContextType(x) {
  switch (x) {
    case "buyer_need" :
      return "BUYER_NEED";
    case "broadcast_message" :
    case "message" :
      return "BROADCAST_MESSAGE";
    case "property" :
      return "FOR_SALE_PROPERTY";
    case "rental_need" :
      return "RENTAL_NEED";
    case "rental_property" :
      return "RENTAL_PROPERTY";
    default:
      return;
  }
}

function encodeContextType(x) {
  switch (x) {
    case "BROADCAST_MESSAGE" :
      return "broadcast_message";
    case "BUYER_NEED" :
      return "buyer_need";
    case "FOR_SALE_PROPERTY" :
      return "property";
    case "RENTAL_NEED" :
      return "rental_need";
    case "RENTAL_PROPERTY" :
      return "rental_property";
  }
}

function decode(param) {
  return Stdlib_Option.flatMap(param, decodeContextType);
}

function encode(param) {
  return Stdlib_Option.map(param, encodeContextType);
}

let ContextTypeParam = {
  decodeContextType: decodeContextType,
  encodeContextType: encodeContextType,
  decode: decode,
  encode: encode
};

let config = Object.fromEntries([
  [
    "context_id",
    QueryParams.UseQueryParams.ParamConfigs.stringParam
  ],
  [
    "context_type",
    {
      encode: encode,
      decode: decode
    }
  ]
]);

let ParamsConfig = {
  ContextTypeParam: ContextTypeParam,
  config: config
};

let UseQueryParams = QueryParams.UseQueryParams.Make({
  config: config
});

let QueryParams_use = UseQueryParams.use;

let QueryParams$1 = {
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  use: QueryParams_use
};

function ConversationsPageRelayCommon$RecordPageView$RecordPage(props) {
  let activeConversationId = props.activeConversationId;
  let secondaryResource = props.secondaryResource;
  let activeConversationIdAsString = Stdlib_Option.getOr(Stdlib_Option.map(activeConversationId, x => {
    if (x.TAG === "Existing") {
      return x._0;
    } else {
      return `new:` + toString(x._0) + `:` + x._1;
    }
  }), "");
  let page = React.useMemo(() => PageViews.Page.makeConversationsPage(Stdlib_Option.flatMap(activeConversationId, id => {
    if (id.TAG === "Existing") {
      return id._0;
    } else {
      return "new";
    }
  }), secondaryResource, undefined), [activeConversationIdAsString]);
  return JsxRuntime.jsx(PageViews.RecordPageView.make, {
    page: page
  });
}

let RecordPage = {
  make: ConversationsPageRelayCommon$RecordPageView$RecordPage
};

function ConversationsPageRelayCommon$RecordPageView$ConversationsList(props) {
  return JsxRuntime.jsx(ConversationsPageRelayCommon$RecordPageView$RecordPage, {
    secondaryResource: undefined,
    activeConversationId: undefined
  });
}

let ConversationsList = {
  make: ConversationsPageRelayCommon$RecordPageView$ConversationsList
};

let convertFragment = ConversationsPageRelayCommon_conversationContext_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsPageRelayCommon_conversationContext_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsPageRelayCommon_conversationContext_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsPageRelayCommon_conversationContext_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsPageRelayCommon_conversationContext_graphql.node, convertFragment, fRef);
}

let ConversationContextFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationsPageRelayCommon$RecordPageView$ConversationViewByConversationContext(props) {
  let conversationContext = useOpt(props.conversationContext);
  let tmp;
  if (conversationContext !== undefined) {
    switch (conversationContext.__typename) {
      case "BuyerNeedV5" :
        tmp = [
          "BUYER_NEED",
          conversationContext.id
        ];
        break;
      case "ForSalePropertyV5" :
        tmp = [
          "PROPERTY",
          conversationContext.id
        ];
        break;
      case "MessageBroadcast" :
        tmp = [
          "BROADCAST_MESSAGE",
          conversationContext.id
        ];
        break;
      case "RentalNeedV5" :
        tmp = [
          "RENTAL_NEED",
          conversationContext.id
        ];
        break;
      case "RentalPropertyV5" :
        tmp = [
          "RENTAL_PROPERTY",
          conversationContext.id
        ];
        break;
      case "__unselected" :
        tmp = undefined;
        break;
    }
  } else {
    tmp = undefined;
  }
  return JsxRuntime.jsx(ConversationsPageRelayCommon$RecordPageView$RecordPage, {
    secondaryResource: tmp,
    activeConversationId: props.activeConversationId
  });
}

let ConversationViewByConversationContext = {
  ConversationContextFragment: ConversationContextFragment,
  make: ConversationsPageRelayCommon$RecordPageView$ConversationViewByConversationContext
};

let RecordPageView = {
  RecordPage: RecordPage,
  ConversationsList: ConversationsList,
  ConversationViewByConversationContext: ConversationViewByConversationContext
};

let convertFragment$1 = ConversationsPageRelayCommonGetClientNames_client_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsPageRelayCommonGetClientNames_client_graphql.node, convertFragment$1, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(ConversationsPageRelayCommonGetClientNames_client_graphql.node, convertFragment$1, fRef);
}

let ClientFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  readInline: readInline
};

function getClientNames(client) {
  let client$1 = RescriptRelay_Fragment.readInlineData(ConversationsPageRelayCommonGetClientNames_client_graphql.node, convertFragment$1, client);
  let match = client$1.contacts;
  let names;
  if (match !== undefined) {
    let edges = match.edges;
    names = edges !== undefined ? Stdlib_Array.keepSome(edges).map(edge => edge.node.displayName) : [];
  } else {
    names = [];
  }
  if (names.length !== 0) {
    return names.join(", ");
  }
}

let Client = {
  ClientFragment: ClientFragment,
  getClientNames: getClientNames
};

exports.EntityType = EntityType;
exports.Conversation = Conversation;
exports.QueryParams = QueryParams$1;
exports.RecordPageView = RecordPageView;
exports.Client = Client;
/* config Not a pure module */
